import EditorVM from './editor-vm';
export default {
  init: function(node) {
    var params = $('#master_record_json').val();

    ko.applyBindingsWithValidation(new EditorVM(params, node), node, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  } 
};
